module.exports = __webpack_public_path__ + "static/media/nav-icon-coaching-egagement-inactive.7749fd44.svg";